import { render, staticRenderFns } from "./PrivacyPolicyLayout.vue?vue&type=template&id=8d1f65ca&scoped=true&"
import script from "./PrivacyPolicyLayout.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyLayout.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyLayout.vue?vue&type=style&index=0&id=8d1f65ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1f65ca",
  null
  
)

export default component.exports